import TrackWrapper from '@/common/TrackWrapper';
import BrandCard from './BrandCard';

const BRANDS = ['Chrysler', 'Dodge', 'Jeep', 'Ram'];

const viewEvent = {
  customAttributes: {
    action: 'viewed',
    level: 'Brand',
    section: 'Brand'
  },
  eventName: 'New Cars'
};

export default function BrandSection() {
  return (
    <TrackWrapper
      aria-labelledby="brand-section-heading"
      element="section"
      event={viewEvent}
      trackOnce
      className="flex flex-col gap-2xl px-2xl py-3xl"
    >
      <h2 className="text-text-strong t-heading-xl" id="brand-section-heading">
        Select a Brand
      </h2>
      <ul className="grid grid-cols-2 gap-md md:grid-cols-4">
        {BRANDS.map(make => (
          <li key={make}>
            <BrandCard make={make} />
          </li>
        ))}
      </ul>
    </TrackWrapper>
  );
}
